export default {
  claims: (state) => state.claims,
  status: (state) => state.status,
  reasons: (state) => state.reasons,
};
